<template>
	<div id="upload-files">
		<bread-crumbs
			v-if="activeTab === 0"
			:title="$t('UploadFiles.UploadFiles')"
			:subTitle="$t('general.SubtitleUploadFile')"
			:sizeTitle="30"
			:lineHeightTitle="37"
			:sizeSubTitle="15"
			:lineHeightSubTitle="18"
		></bread-crumbs>
		<div :class="activeTab === 0 ? 'vx-card p-4' : ''">
			<div v-if="activeTab === 0" class="tab-text">
				<UploadFileList
					v-if="uploadfileUpdatePermission || (uploadfileCreatePermission && uploadFile.id === 0)"
					@selectedUploadFileEmit="selectedUploadFileEmit"
					@valueCreateSchelude="valueAlarmZoneEmit"
				/>
				<not-permission v-else></not-permission>
			</div>
			<div v-else-if="activeTab === 1" class="tab-text">
				<transition name="fade">
					<upload-file-form
						v-if="uploadfileCreatePermission && showUploadFile"
						ref="UploadFileForm"
						@uploadStatusEmit="uploadStatusEmit"
						@changeActiveTabEmit="valueAlarmZoneEmit"
					/>
				</transition>
				<transition name="fade">
					<set-equivalences
						v-if="uploadfileCreatePermission && showSetEquivalence"
						ref="SetEquivalences"
						@closeEquivalenceEmit="closeEquivalenceEmit"
						@cancelEquivalenceEmit="cancelEquivalenceEmit"
						@changeActiveTabEmit="valueAlarmZoneEmit"
					></set-equivalences>
				</transition>
				<!-- <not-permission v-else></not-permission> -->
			</div>
		</div>
	</div>
</template>

<script>
import UploadFileForm from "./UploadFileForm.vue";
import UploadFileList from "./UploadFileList";
import NotPermission from "@/views/pages/NotPermission.vue";
import UploadedFile from "@/models/UploadedFile.js";
import SetEquivalences from "./SetEquivalences.vue";

export default {
	components: {
		UploadFileForm,
		UploadFileList,
		NotPermission,
		SetEquivalences,
	},
	data() {
		return {
			activeTab: 0,
			uploadFile: new UploadedFile({}),
		};
	},
	created() {
		const active_tab = this.$route.params.active_tab;
		if (active_tab) {
			this.activeTab = active_tab;
		}
	},
	watch: {
		activeTab(val) {
			if (val === 0) {
				this.uploadFile = new UploadedFile({});
			}
		},
	},
	computed: {
		uploadfileReadPermission() {
			return this.$store.getters.checkPermission("UPLOAD_FILES_R");
		},
		uploadfileCreatePermission() {
			return this.$store.getters.checkPermission("UPLOAD_FILES_C");
		},
		uploadfileUpdatePermission() {
			return this.$store.getters.checkPermission("UPLOAD_FILES_U");
		},
		activeTabName() {
			if (this.uploadFile.id > 0) {
				return this.$t("ManualData.ManageError");
			} else {
				return this.$t("Reports.History");
			}
		},
		showSetEquivalence() {
			return this.$store.state.uploadFile.showSetEquivalence;
		},
		showUploadFile() {
			return this.$store.state.uploadFile.showUploadFile;
		},
	},
	methods: {
		selectedUploadFileEmit(object) {
			this.uploadFile = new UploadedFile(object);
			this.activeTab = 1;
		},
		valueAlarmZoneEmit(val) {
			this.activeTab = val;
			if (this.activeTab === 0) {
				this.uploadFile = new UploadedFile({});
			}
		},
		uploadStatusEmit(val) {
			if (val) {
				this.$store.commit("uploadFile/SET_SHOW_EQUIVALENCES", true);
				this.$store.commit("uploadFile/SET_SHOW_UPLOAD_FILE", false);
			}
		},
		closeEquivalenceEmit() {
			this.cancelEquivalenceEmit();
			setTimeout(() => {
				this.$refs.UploadFileForm.showSuccessUpload();
			}, 200);
		},
		cancelEquivalenceEmit() {
			this.$store.commit("uploadFile/SET_SHOW_EQUIVALENCES", false);
			this.$store.commit("uploadFile/SET_SHOW_UPLOAD_FILE", true);
			this.$store.commit("uploadFile/SET_EQUIVALENTS", null);
			this.$store.commit("uploadFile/SAVE_UPLOAD", null);
		},
	},
};
</script>

<style lang="scss" scoped>
#content-router-selection {
	height: 100%;
}

.fade-enter-active {
	transition: opacity 0.7s;
}

.fade-leave-active {
	transition: opacity 0.3s;
}

.fade-enter,
.fade-leave-to {
	opacity: 0;
}
</style>
